(function($) {

	/**
	* This lib takes VB Format strings and formats numbers/dates.
	* It could benefit from the addition of caching parsed format strings.
	*
	* @author Matt.Dunlap
	* Managed through Subversion, no VSS
	*/


	/**
	* Format numbers!
	* @param {number} value Number to be formatted
	* @param {string} format VB format string
	*/

	$.formatNumber = function(value, format) {
		if (!isFinite(value)) {
			return "--";
		}

		value = Number(value);

		var type = 'default';
		if (format instanceof Array) {
			if (value == 0 && format.length > 2 && format[2]) {
				return format[2];
			} else if (value < 0 && format.length > 1 && format[1]) {
				format = format[1];
				type = 'neg';
			} else {
				format = format[0];
			}
		}

		var parsedFormat = format.match(/([^#0]*)([#0][#0,]*)(\.?)([#0]*)([\s\S]*)/);

		var headFormat = parsedFormat[1]; // Prepended string
		var leftFormat = parsedFormat[2]; // Format to left of decimal place
		var rightFormat = parsedFormat[4]; // Format to right of decimal place
		var tailFormat = parsedFormat[5]; // Appended string
		var negative = (value < 0);
		if (negative) value *= -1;

		var reComma = /,/g;
		var showCommas = reComma.test(leftFormat);
		if (showCommas) {
			leftFormat = leftFormat.replace(reComma, '');
			reComma.lastIndex = 0;
		}

		var isPercentage = /^\s*%/.test(tailFormat);
		if (isPercentage) value *= 100;

		var magSuffixes = tailFormat.match(/^\s*\[([\w\s\\|]+)\]/);
		var magBase = 1000,
			suffix = '';
		if (magSuffixes) {
			if (value) {
				magSuffixes = magSuffixes[1];
				if (magSuffixes.toLowerCase() == 'bytes') {
					magSuffixes = ['b', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB'];
					magBase = 1024;
				} else {
					magSuffixes = magSuffixes.split('|');
				}
				var mag = Math.floor(Math.log(value) / Math.log(magBase));
				mag = Math.max(0, Math.min(magSuffixes.length - 1, mag));
				suffix = magSuffixes[mag];
				if (suffix.length) value /= Math.pow(magBase, mag);
			}
			tailFormat = tailFormat.replace(/\[([\w\s|]+)\]/, suffix);
		}

		var unescape = /\\([\s\S])/g;
		tailFormat = tailFormat.replace(unescape, '$1');
		headFormat = headFormat.replace(unescape, '$1');

		var leftFixed = leftFormat.match(/0*$/)[0].length; // The minimum number of digits to left of decimal (we pad with zeros)
		parsedFormat = rightFormat.match(/^(0*)#*/);
		var rightAllowed = parsedFormat[0].length; // The maximum number of digits to right of decimal (we round here)
		var rightFixed = parsedFormat[1].length; // The minimum number of digits to right of decimal (we pad with zeros)
		// Perform any rounding and pad right with zeros
		value = value.toFixed(rightAllowed);

		// Prepended string
		var result = [headFormat];

		// Left of decimal
		var leftValue = parseInt("0" + value, 10).toString();
		if (leftValue == '0' && leftFixed < 1) {
			leftValue = '';
		} else {
			while (leftValue.length < leftFixed) leftValue = '0' + leftValue;
			if (showCommas) {
				var reCommatize = /(\d+)(\d{3}[\d,]*)$/g;
				while (reCommatize.test(leftValue)) {
					leftValue = leftValue.replace(reCommatize, '$1,$2');
					reCommatize.lastIndex = 0;
				}
			}
		}
		result.push(negative && type != 'neg' ? '-' : '', leftValue);

		// Decimal point plus digits to right of decimal
		if (rightFixed > 0 || (rightAllowed > 0 && (value % 1) != 0)) {
			var rightValue = String(value).match(/\.\d*$/)[0];
			if (rightFixed < rightAllowed) rightValue = rightValue.replace(new RegExp('0{0,' + (rightAllowed - rightFixed) + '}$'), '');
			result.push(rightValue);
		}

		// Appended string
		result.push(tailFormat);

		return result.join('');

	}; // end formatNumber()

	$.formatPrice = function(value, hasSign, hidePriceSign) {
		var fValue = "--";
		if (!isFinite(value)) { return fValue; }

		var abs = Math.abs(value);
		var pre = hasSign ? "+" : "";
		var dollarSign = hidePriceSign ? "" : "$";

		// TT0197723 Removed all decimal place conditionals for prices below $2 and above $999.
		// All prices will show at least two decimals and up to four decimal places 
		// when trailing two decimals are not 0s.
		fValue = $.formatNumber(value, pre + dollarSign + "###,##0.00##");
		return fValue;
	};

	$.formatDistributionRangeValueForSlider = function (value, noDecimals) {
	    if (value == "") {
	        return value;
	    }

	    return noDecimals == true
	        ? $.formatNumber((Number(value)), "###,##0[||M|B|T]")
            : $.formatNumber((Number(value)).toFixed(4), "###,##0.00[||M|B|T]");
	};

	$.formatDistributionRangeValueForDropdown = function (value, noDecimals) {
	    if (value == "") {
	        return value;
	    }

	    return noDecimals == true
            ? $.formatNumber((Number(value)), "###,##0[||M|B|T]")
            : $.formatNumber((Number(value)).toFixed(4), "###,##0.00[||M|B|T]");
	};

	$.formatPriceColor = function(value) {
		return "<span class=\"color " + $.formatGetColor(value) + "\">" + $.formatPrice(value, true, true) + "</span>";
	};

	$.formatGetColor = function(value) {
		var color = "unch";
		if (value > 0) {
			color = "pos";
		} else if (value < 0) {
			color = "neg";
		}

		return color;
	};

	$.formatGetSign = function(value) {
		if (value > 0) {
			return "+" + value;
		}

		return value;
	};

	$.formatGetSignPercent = function (value) {
		if (value > 0) {
			return "+" + value + "%";
		}
		else if(value !== "--"){
			return value + "%";
		}
		return value;
	};

	$.formatGetPercent = function (value) {
		if (value !== "--") {
			return value + "%";
		}
		return value;
	};

	$.formatColor = function(value) {
		if (!isFinite(value)) {
			return "--";
		}

		return "<span class=\"color " + $.formatGetColor(value) + "\">" + value + "</span>";
	};

	$.formatColorWithSign = function(value, isPercent, hasCommas) {
		if (!isFinite(value)) {
			return "--";
		}

		var fValue = $.formatGetSign(value);

		if (isPercent) {
			fValue = fValue + "%";
		}

		if (hasCommas) {
			var pre = fValue > 0 ? "+" : "";
			fValue = $.formatNumber(fValue, pre + "###,#00.00##");
		}

		return "<span class=\"color " + $.formatGetColor(value) + "\">" + fValue + "</span>";
	};

	// format color change with arrow
	$.formatColorArrow = function(value) {
		if (!isFinite(value)) {
			return "--";
		}

		return "<span class=\"color " + $.formatGetColor(value) + " arrow\"><span class=\"icons\">&nbsp;</span>" + value + "</span>";
	};

	// format color change pct with parens
	$.formatColorPctParens = function(value) {
		if (!isFinite(value)) {
			return "--";
		}

		return "<span class=\"color " + $.formatGetColor(value) + "\">(" + $.formatGetSign(value) + "%)</span>";
	};

	// format color change pct with parens
	$.formatColorPctParensNoSign = function(value) {
		if (!isFinite(value)) {
			return "--";
		}

		return "<span class=\"color " + $.formatGetColor(value) + "\">(" + Math.abs(value) + "%)</span>";
	};

	$.formatBidAsk = function(value, size, noPriceSign, last) {
		if (!isFinite(value)) {
			return "--";
		}
		if (value == null || !isFinite(size)) {
			size = "--";
		}
		var color = $.formatGetColor((value - last) || 0);
		if (size >= 100000) {
			size = $.formatNumber(size, "###.#[|K|M|B|T]");
		}			
		return "<span class=\"color " + color + "\">"
			+ $.formatPrice(value,false,noPriceSign)
			+ "<span class=\"color subData subData" + color + "\">/" + size + "</span>"
			+ "</span>";
	};

	$.formatTimeStamp = function(value) {
		if (!isFinite(value)) {
			return "--";
		}
		var tObj = $.formatGetDateValues(value);
		return tObj.date + " " + tObj.month + " " + tObj.year + " " + tObj.hh + ":" + tObj.mm + tObj.tt + " " + wsod_timezone();
	};

	$.formatShortDate = function(value) {
		if (!isFinite(value)) {
			return "--";
		}
		var tObj = $.formatGetDateValues(value);
		return tObj.date + " " + tObj.month + " " + tObj.year;
	};

	$.formatGetDateValues = function(value) {
		var newDate = new Date(Math.floor(value));

		var intYear = newDate.getFullYear();
		var intMonth = 1 + newDate.getMonth();
		var intDay = newDate.getDate();

		var century = 0;
		while ((intYear - century) >= 100) {
			century = century + 100;
		}

		var year = intYear;

		var month = intMonth < 10 ? '0' + (intMonth) : (intMonth);
		var date = intDay < 10 ? '0' + (intDay) : (intDay);
		var intHH = newDate.getHours();
		var isPM = false;
		if (intHH > 12) {
			intHH -= 12;
			isPM = true;
		}
		var hh = intHH < 10 ? '0' + (intHH) : (intHH);
		var intMM = newDate.getMinutes();
		var mm = intMM < 10 ? '0' + (intMM) : (intMM);

		return {
			date: date
			, month: month
			, year: year
			, hh: hh
			, mm: mm
			, tt: isPM ? "pm" : "am"
		};
	};

	$.formatMonthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

	$.formatMonthDayYear = function(value) {
		if (!isFinite(value)) {
			return "--";
		}
		var newDate = new Date(value);

		var intYear = newDate.getFullYear();
		var sMonth = $.formatMonthNames[newDate.getMonth()];
		var intDay = newDate.getDate();

		var century = 0;
		while ((intYear - century) >= 100) {
			century = century + 100;
		}

		var yy = intYear - century;
        if (yy < 10) { yy = '0' + yy };

		return sMonth + " " + intDay + ", " + intYear;
	};

	//convert to milliseconds
	$.formatConvertToMS = function(value) {
		return (value * 60 * 1000);
	};

	$.formatConvertMsDateToMS = function(msDate) {
		return $.formatConvertToMS((msDate - 25569) * 24 * 60);
	};

	$.formatConvertToJSDate = function(value) {

		var jO;
		if (typeof (value) != "object") {

			jO = new Date(((value - 25569) * 86400000));
			var tz = jO.getTimezoneOffset();
			jO = new Date(((value - 25569 + (tz / (60 * 24))) * 86400000));
		} else {
			jO = value;
		}
		return jO;
	};

	$.isNumber = function(value) {
		var RegExp = /^(-)?(\d*)(\.?)(\d*)$/;
		return value.match(RegExp);
	};


})(jQuery);